"use client";

import { c as _c } from "react/compiler-runtime";
import { faPauseCircle, faPlayCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useSwiper } from "swiper/react";
import useCapacitor from "@/hooks/useCapacitor";
interface SwiperAutoplayButtonProps {
  readonly isInViewport: boolean;
}
export default function SwiperAutoplayButton(t0) {
  const $ = _c(11);
  const {
    isInViewport
  } = t0;
  const swiper = useSwiper();
  const {
    isCapacitor
  } = useCapacitor();
  const [manuallyPaused, setManuallyPaused] = useState(isCapacitor);
  let t1;
  let t2;
  if ($[0] !== isInViewport || $[1] !== manuallyPaused || $[2] !== swiper.autoplay) {
    t1 = () => {
      if (manuallyPaused || !isInViewport) {
        swiper.autoplay.stop();
      } else {
        if (isInViewport && !manuallyPaused) {
          swiper.autoplay.start();
        }
      }
    };
    t2 = [manuallyPaused, isInViewport, swiper.autoplay];
    $[0] = isInViewport;
    $[1] = manuallyPaused;
    $[2] = swiper.autoplay;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: "24px",
      cursor: "pointer"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== manuallyPaused) {
    t4 = () => {
      setManuallyPaused(!manuallyPaused);
    };
    $[6] = manuallyPaused;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = manuallyPaused ? faPlayCircle : faPauseCircle;
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="text-center"><FontAwesomeIcon style={t3} onClick={t4} icon={t5} /></div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}